import { useEffect, useId, useLayoutEffect, useRef, useState } from "react";
import navRuleUrl from "../assets/hello/nav-underline.svg";

const NAV = [
  { id: "hello", href: "#hello", label: "Hello!" },
  { id: "about", href: "#about", label: "About" },
  { id: "resume", href: "#resume", label: "Résumé" },
  { id: "portfolio", href: "#portfolio", label: "Portfolio" },
  { id: "connect", href: "#connect", label: "connect" },
] as const;

const IMPLEMENTED = new Set<string>(["hello", "about", "resume", "portfolio", "connect"]);

export default function SiteNav({
  current,
  onNavigate,
}: {
  current: string;
  onNavigate?: (id: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const menuId = useId();
  const scrollTarget = useRef<string | null>(null);

  useLayoutEffect(() => {
    const id = scrollTarget.current;
    if (!id || open) return;
    scrollTarget.current = null;
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }, [open]);

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    const onResize = () => {
      if (window.matchMedia("(min-width: 861px)").matches) setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <div className={`site-nav${open ? " is-open" : ""}`}>
      <button
        type="button"
        className="site-menu"
        aria-expanded={open}
        aria-controls={menuId}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="sr-only">{open ? "Close menu" : "Open menu"}</span>
        <span className="site-menu-mark" aria-hidden="true" />
      </button>
      <nav id={menuId} className="hello-nav" aria-label="Primary">
        {NAV.map((item) => {
          const active = item.id === current;
          return (
            <a
              key={item.href}
              href={item.href}
              className="hello-nav-link"
              aria-current={active ? "page" : undefined}
              onClick={(event) => {
                if (!IMPLEMENTED.has(item.id)) {
                  event.preventDefault();
                  return;
                }
                event.preventDefault();
                onNavigate?.(item.id);
                if (window.location.hash !== item.href) {
                  window.history.pushState(null, "", item.href);
                }
                if (open) {
                  scrollTarget.current = item.id;
                  setOpen(false);
                } else {
                  document.getElementById(item.id)?.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              <span>{item.label}</span>
              <img className="hello-nav-rule" src={navRuleUrl} alt="" />
            </a>
          );
        })}
      </nav>
    </div>
  );
}
